@if (!loading) {
  <div class="library-list">
    @switch (layout) {
      @case (layoutTypes.GRID) {
        <div
          class="library-list-grid"
          cdkDropListGroup
          [cdkDropListGroupDisabled]="!canReorder"
          data-cy="library-list-grid">
          @for (item of items; track item) {
            <div
              cdkDropList
              class="library-drop-list"
              [ngClass]="'type-' + item.type"
              [class.folder-reorder]="folderReorder"
              [cdkDropListConnectedTo]="dropListConnectedTo"
              [cdkDropListData]="item"
              [cdkDropListEnterPredicate]="canDrop"
              [cdkDropListDisabled]="!canReorder"
              (cdkDropListDropped)="drop($event, false, folderReorder)">
              <lib-library-item-card
                cdkDrag
                class="library-card"
                [item]="item"
                [cdkDragDisabled]="!canReorder"
                [cdkDragData]="item"
                [contextTemplate]="contextMenuItemsEnabled[item.id] ? contextMenuTmp : null"
                (open)="onOpen(item)"
                (cdkDragEntered)="onDragEntered($event)"
                (cdkDragStarted)="onDragStarted()"
                (cdkDragEnded)="onDragEnded()">
                <ng-template cdkDragPlaceholder>
                  <div class="library-drag-placeholder">
                    <div></div>
                  </div>
                </ng-template>
                <div *cdkDragPreview class="library-card-drag-preview">
                  <lib-library-item-icon [item]="item" [size]="24"></lib-library-item-icon>
                  {{ item.name }}
                </div>
              </lib-library-item-card>
              @if (canEditAndDelete) {
                <lib-library-item-card
                  class="library-card dragged-item-placeholder"
                  [contextTemplate]="contextMenuItemsEnabled[item.id] ? contextMenuTmp : null"
                  [item]="item">
                </lib-library-item-card>
              }
            </div>
          }
        </div>
      }
      @case (layoutTypes.CAROUSEL) {
        <div class="library-list-carousel" data-cy="library-list-carousel">
          <lib-swiper [slides]="items" [options]="swiperOptions">
            <ng-template swiperContent let-slide="item">
              <lib-library-item-card
                class="library-card"
                [contextTemplate]="contextMenuItemsEnabled[slide.id] ? contextMenuTmp : null"
                (open)="onOpen(slide)"
                [item]="slide">
              </lib-library-item-card>
            </ng-template>
          </lib-swiper>
        </div>
      }
      @default {
        <lib-library-list-table
          [items]="items"
          [defaultSort]="defaultSort"
          [canReorder]="canReorder"
          (open)="onOpen($event)"
          (reorder)="drop($event?.dragDrop, true, $event.folderReorder)"
          (sortChange)="tableSortChanged($event)"
          [dropListConnectedTo]="dropListConnectedTo"
          [contextTemplate]="contextButtonEnabled ? contextMenuTmp : null"
          [additionalActionsTemplate]="tableActionsTemplate">
        </lib-library-list-table>
      }
    }
    <ng-template #contextMenuTmp let-item="item">
      @if (contextMenuItemsEnabled[item.id]) {
        @if (viewDetailsButton) {
          <button class="library-context-menu-item" mat-menu-item (click)="openDetails.emit(item)">
            <lib-icon icon="info" [size]="24"></lib-icon>
            {{ 'LIBRARY_PAGE.view_details' | translate }}
          </button>
        }
        @if (item.canDownload && item.type !== libraryTypes.FOLDER) {
          <button class="library-context-menu-item" mat-menu-item (click)="download.emit(item)">
            <lib-icon icon="download-simple" [size]="24"></lib-icon>
            {{ 'LIBRARY_PAGE.download' | translate }}
          </button>
        }
        @if (canEditAndDelete) {
          @if (item._meta?.operations?.edit) {
            <button class="library-context-menu-item" mat-menu-item (click)="edit.emit(item)" data-cy="library-item-edit">
              <lib-icon icon="pencil" [size]="24"></lib-icon>
              {{ 'COMMON.edit' | translate }}
            </button>
          }
          @if (item._meta?.operations?.delete) {
            <button class="library-context-menu-item" mat-menu-item (click)="delete.emit(item)" data-cy="library-item-delete">
              <lib-icon icon="trash" [size]="24"></lib-icon>
              {{ 'COMMON.delete' | translate }}
            </button>
          }
        }
        @if (enablePinned) {
          <button mat-menu-item class="library-context-menu-item" (click)="pinnedChanged.emit(item)" data-cy="library-context-menu-pin">
            <lib-icon icon="push-pin" [fill]="item.userPin"></lib-icon>
            {{(item.userPin ? 'LIBRARY.unpin' : 'LIBRARY.pin') | translate}}
          </button>
        }
        @if (notifyButtonEnabled && item._meta?.operations?.sendNotification) {
          <button mat-menu-item class="library-context-menu-item" (click)="notifyUsers.emit(item)" data-cy="library-context-menu-notification">
            <lib-icon icon="bell"></lib-icon>
            {{'COMMON.notity_users' | translate}}
          </button>
        }
        @if (reportCreationEnabled && item.type !== libraryTypes.FOLDER) {
          <button mat-menu-item class="library-context-menu-item" (click)="createReport.emit(item)" data-cy="library-context-menu-create-report">
            <lib-icon icon="chart-line-up"></lib-icon>
            {{'COMMON.create_report' | translate}}
          </button>
        }
      } @else {
        <button class="library-context-menu-item" disabled mat-menu-item data-cy="library-item-no-actions">
          {{ 'COMMON.no_actions' | translate }}
        </button>
      }
    </ng-template>
  </div>
} @else {
  <div class="library-list skeleton-view">
    @switch (layout) {
      @case (layoutTypes.GRID) {
        <div class="skeleton-view-grid">
          @for (item of placeholders; track $index) {
            <div class="skeleton-card">
              <lib-skeleton-loader class="skeleton-card-image"></lib-skeleton-loader>
              <lib-skeleton-loader class="skeleton-card-title" height="20px" width="60%"></lib-skeleton-loader>
              <lib-skeleton-loader class="skeleton-card-info" height="16px" width="90%"></lib-skeleton-loader>
            </div>
          }
        </div>
      }
      @default {
        <div class="skeleton-view-list">
          <div class="skeleton-view-list-header">
            <div>
              <lib-skeleton-loader height="18px" width="80px"></lib-skeleton-loader>
            </div>
            <div>
              <lib-skeleton-loader height="18px" width="60px"></lib-skeleton-loader>
            </div>
            <div>
              <lib-skeleton-loader height="18px" width="60px"></lib-skeleton-loader>
            </div>
            <div>
              <lib-skeleton-loader height="18px" width="60px"></lib-skeleton-loader>
            </div>
          </div>
          @for (item of placeholders; track $index; let index = $index) {
            <div class="skeleton-row">
              <lib-skeleton-loader height="60px" [style.opacity]="1 - index * .2"></lib-skeleton-loader>
            </div>
          }
        </div>
      }
    }
  </div>
}


